import { message } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { SystemRoleName } from '@evimo/types/enums/system-role-name';
import { useAuth } from '~/app/auth/context/AuthContext';
import { triggerIziviaMonprojetCases } from '~/app/services/izivia/izivia-monprojet-cases.service';
import { isSigeifOrganization } from '../utils';

export function useTriggerIziviaMonprojetCases(organizationId: string) {
  const { user } = useAuth();
  const { t } = useTranslation('organization');
  const isSuperAdmin = user?.roleName === SystemRoleName.SUPER_ADMIN;
  const canTrigger = isSuperAdmin && isSigeifOrganization(organizationId);

  const mutation = useMutation({
    mutationFn: () => {
      if (!isSigeifOrganization(organizationId)) {
        return Promise.reject(new Error(''));
      }
      return triggerIziviaMonprojetCases(organizationId);
    },
    onSuccess: () => {
      message.success(t('messages.triggerIziviaMonprojetCasesSuccess'));
    },
    onError: (error: Error) => {
      message.error(
        error.message || t('messages.triggerIziviaMonprojetCasesFailed'),
      );
    },
  });

  return {
    canTrigger,
    isPending: mutation.isPending,
    onTrigger: () => {
      if (!canTrigger || mutation.isPending) {
        return;
      }
      mutation.mutate();
    },
  };
}
